export const LikeState = {
  Like: "like",
  Unlike: "unlike",
};
